import { Link, useLocation } from "react-router-dom";

const NAV_LINKS = [
  { to: "/events", label: "Events" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

function HeaderNav() {
  const location = useLocation();

  return (
    <header className="bentolio-card bentolio-card--header header-nav">
      <div className="header-nav__inner">
        <Link to="/" className="nav-logo">
          <span className="nav-logo__peanut">Peanut Butter</span>
          <span className="nav-logo__jelly"> And Jelly</span>
        </Link>
        <nav className="nav-links" aria-label="Main navigation">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={location.pathname.startsWith(link.to) ? "nav-link--active" : undefined}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default HeaderNav;
